import type { CallIntroStep } from "@/customer-panel/components/call-intro-flow/store/CallIntroStore";
import type { CustomerVerificationStep } from "@/customer-panel/components/customer-verification-store";
import type { IVRInfo } from "@/sdk";

import { isIVRHandoffStep } from "@/customer-panel/components/customer-verification/utils/isIVRHandoffStep";

export function calcIsEditing(params: {
    isCustomerFlowComplete: boolean;
    stepHistory: string[];
    callIntroStepHistory: string[];
}) {
    const { isCustomerFlowComplete, stepHistory, callIntroStepHistory } = params;
    return (
        !isCustomerFlowComplete &&
        (stepHistory.includes("VerificationComplete") || callIntroStepHistory.includes("IntroFlowCompleted"))
    );
}

export function calcShouldShowCustomerProfile(params: {
    isChat: boolean;
    isCustomerFlowComplete: boolean;
    isEditing: boolean;
    callIntroStep: CallIntroStep;
    stepHistory: CustomerVerificationStep[];
    isEnhancedCustomerSearchEnabled: boolean;
    ivrInfo: IVRInfo | undefined;
}) {
    const {
        isChat,
        isCustomerFlowComplete,
        isEditing,
        callIntroStep,
        stepHistory,
        isEnhancedCustomerSearchEnabled,
        ivrInfo,
    } = params;

    return (
        isChat ||
        isCustomerFlowComplete ||
        isEditing ||
        !isIVRHandoffStep({ callIntroStep, stepHistory, isEnhancedCustomerSearchEnabled, ivrInfo })
    );
}
